import Api from  "@/services/AxiosAPI";

export default {

  payment(myJSON, auth, order, token, Total, paymenttype) {
    var shipping = JSON.parse(myJSON);
    const post = new FormData();
    post.append("name", shipping.first_name);
    post.append("grandTotal", Total);
    post.append("address1", shipping.address_1);
    post.append("address2", shipping.address_2);
    post.append("address3", shipping.address_3);
    post.append("postcode", shipping.postcode);
    post.append("telephoneNumber", shipping.phone);
    post.append("countryCode", shipping.country_id);
    post.append("billingAddress", shipping.first_name);
    post.append("Total", Total);
    post.append("orderId", order);
    post.append("token", token);
    post.append("paymentType",paymenttype)
    post.append("invoiceNumber",1);
    post.append("city",shipping.town);
    post.append("returnUrl","returnUrl");
    // Card 
    return Api.postData('makePayment', post)
      .then(responses => {
        return responses
      });

  },
  trainingCoursePayment(myJSON, auth, order, token, Total, paymenttype) {
    var shipping = JSON.parse(myJSON);
    const post = new FormData();
    post.append("name", shipping.first_name);
    post.append("grandTotal", Total);
    post.append("address1", shipping.address_1);
    post.append("address2", shipping.address_2);
    post.append("address3", shipping.address_3);
    post.append("postcode", shipping.postcode);
    post.append("telephoneNumber", shipping.phone);
    post.append("countryCode", shipping.country_id);
    post.append("billingAddress", shipping.first_name);
    post.append("Total", Total);
    post.append("orderId", order);
    post.append("token", token);
    post.append("paymentType",paymenttype)
    post.append("invoiceNumber",1);
    post.append("city",shipping.town);
    post.append("returnUrl","returnUrl");
    // Card 
    return Api.postData('makePayment', post)
      .then(responses => {
        return responses
      });

  },
  paypalPayment(myJSON, auth, order, Total) {
    var shipping = JSON.parse(myJSON);
    const post = new FormData();
    post.append("name", shipping.first_name+' '+shipping.last_name);
    post.append("first_name", shipping.first_name);
    post.append("last_name", shipping.last_name);
    post.append("grandTotal", Total);
    post.append("address1", shipping.address_1);
    post.append("address2", shipping.address_2);
    post.append("address3", shipping.address_3);
    post.append("postcode", shipping.postcode);
    post.append("telephoneNumber", shipping.mobile_phone);
    post.append("countryCode", shipping.country_id);
    post.append("billingAddress", shipping.first_name);
    post.append("Total", Total);
    post.append("orderId", order);
    post.append("invoiceNumber",1);
    post.append("city",shipping.town);
    // Card 
    return Api.postData('paypal/create-order', post)
      .then(responses => {
        return responses
      });

  },

  paypalPaymentCapture(order_id, paypal_order_id,amount) {
    const post = new FormData();
    post.append("order_id", order_id);
    post.append("paypal_order_id", paypal_order_id);
    post.append("amount", amount);
    // Card 
    return Api.postData('paypal/capturePaymentForOrder', post)
      .then(responses => {
        return responses
      });

  },
  /*
  *WPA
  */
  createToken(myJSON, auth, order, sessionState, Total) {
    var shipping = JSON.parse(myJSON);
    const post = new FormData();
    post.append("Nameoncard", shipping.Nameoncard);
    post.append("name", shipping.first_name);
    post.append("grandTotal", Total);
    post.append("address1", shipping.address_1);
    post.append("address2", shipping.address_2);
    post.append("address3", shipping.address_3);
    post.append("postcode", shipping.postcode);
    post.append("telephoneNumber", shipping.phone);
    post.append("countryCode", shipping.country_id);
    post.append("billingAddress", shipping.first_name);
    post.append("Total", Total);
    post.append("orderId", order);
    post.append("sessionState", sessionState);
    post.append("invoiceNumber",1);
    post.append("city",shipping.town);
    post.append("returnUrl","returnUrl");
    post.append("paymentType",'Card');
    // Card 
    return Api.postData('worldpay-access/create-token', post)
      .then(responses => {
        return responses
      });

  },
  handleDeviceDataResponse(transaction_reference,response,Total){
    const post = new FormData();
    post.append('transaction_reference',transaction_reference);
    post.append("grandTotal", Total);
    post.append('user-agent',navigator.userAgent);
    for (const [key, value] of Object.entries(response)) {
      post.append(key,value);
    }
    return Api.postData('worldpay-access/device-data', post)
    .then(responses => {
      return responses
    });
  },
  authorizeThreeds(transaction_reference,response,Total){
    const post = new FormData();
    post.append('transaction_reference',transaction_reference);
    post.append("grandTotal", Total);
    for (const [key, value] of Object.entries(response)) {
      post.append(key,value);
    }
    return Api.postData('worldpay-access/3ds-response', post)
    .then(responses => {
      return responses
    });
  },

  // ── KEV-748: New Worldpay v2 flow ──────────────────────────────

  /**
   * Step 1: Authorize — send session state + billing to create token & get DDC data
   */
  authorizePayment(formData) {
    return Api.postData('worldpay/authorize', formData)
      .then(responses => {
        return responses;
      });
  },

  /**
   * Step 2: Supply 3DS device data — send DDC result (collectionReference)
   */
  supply3dsDeviceData(formData) {
    return Api.postData('worldpay/supply-3ds', formData)
      .then(responses => {
        return responses;
      });
  },

  /**
   * Step 3: Complete 3DS challenge — send challenge result
   */
  completeChallenge(formData) {
    return Api.postData('worldpay/complete-challenge', formData)
      .then(responses => {
        return responses;
      });
  }
}